import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import parse from "html-react-parser";
import { FaTrash } from "react-icons/fa";
import ServiceModal from "../services/ServiceModel";
import ServiceCalendar from "./ServiceCalendar";
import { isLogin } from "./../../../../helpers/login";
import { toast } from "react-toastify";
import ServiceCalendarAuth from "./ServiceCalendarAuth";
import googleMeet from "./../../../../assets/icons/google-meet-logo.svg";
import { useHistory } from "react-router-dom";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import { useLocation } from "react-router-dom";
import PlaceOrderModal from "./PlaceOrderModal";
import SimpleMapDisplay from "../../../../components/SimpleMapDisplay";

function ServiceDetailsTabbing(props) {
  const history = useHistory();
  const location = useLocation();
  const accessToken = localStorage.getItem("accessToken");
  const [zoomAccessToken, setZoomAccessToken] = useState(null);
  const [zoom_userId, setZoom_userId] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [averageRating, setAverageRating] = useState(0);
  const [eventList, setEventList] = useState([]);
  // const [isCalendarAuthorized, setIsCalendarAuthorized] = useState(accessToken ? true : false);
  const [isCalendarAuthorized, setIsCalendarAuthorized] = useState(false);
  const { scrollToReviews, scheduledMeeting, serviceCreator, chargesPayStatus, serviceName, sellerId, showOrderPopup } = props;

  const [activeTab, setActiveTab] = useState("description");

  // Get seller location data from props (passed down from parent component)
  const [sellerLocationData, setSellerLocationData] = useState(null);

  useEffect(() => {
    // Extract seller location data from service details
    // This should be passed as props from the parent component
    if (props.sellerData && props.sellerData.address) {
      setSellerLocationData(props.sellerData.address);
    }
  }, [props.sellerData]);

  useEffect(() => {
    if (accessToken) {
      setIsCalendarAuthorized(true)
    } else {
      console.log("Calender token is expired....");
      // setIsCalendarAuthorized(false)
    }
  }, []);


  useEffect(() => {
    if (scrollToReviews) {
      setActiveTab("reviews");
    }
  }, [scrollToReviews]);

  useEffect(() => {
    if (scheduledMeeting) {
      setActiveTab("appointment");
      if (authInfo && authInfo.token) {
        eventMeeting();
      }
    }
  }, [scheduledMeeting]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const paymentStatus = queryParams.get('paymentResponse');
    if (paymentStatus === 'true') {
      setActiveTab("appointment");
    }
  })

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(3);

  useEffect(() => {
    fetchApi();
    if (authInfo && authInfo.token) {
      eventMeeting();
      if (accessToken) {
        console.log("if token then run....")
        fetchPastEvents();
      }
    }
    // updateServiceOrders();
  }, []);

  const authInfo = JSON.parse(localStorage.getItem("authInfo"));
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const serviceId = props.serviceId;

  const fetchApi = async () => {
    try {
      const response = await axios.get(`/user/get-service-review/${serviceId}`);
      const result = response.data.data;
      setReviews(result);
      if (result.length > 0) {
        const totalRating = result.reduce((acc, curr) => acc + curr.rating, 0);
        const average = totalRating / result.length;
        setAverageRating(average);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const deleteReview = async (reviewId) => {
    try {
      const headers = {
        Authorization: `Bearer ${authInfo.token}`,
      };
      await axios.delete(`/user/delete-review/${reviewId}`, { headers });
      fetchApi();
      toast.success("Review Deleted Successfully");
    } catch (error) {
      toast.error("Review hasn't been deleted");
      console.log("Error deleting review:", error);
    }
  };

  const renderStarRating = (ratingValue) => {
    const stars = [];
    // Calculate full stars
    const fullStars = Math.floor(ratingValue);
    // Check if there's a half star
    const hasHalfStar = ratingValue - fullStars >= 0.5;
    // Iterate through 5 stars
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        // Full star
        stars.push(<li className="star rated" key={i}></li>);
      } else if (hasHalfStar && i === fullStars) {
        // Half star
        stars.push(<li className="star half-star" key={i}></li>);
      } else {
        // Empty star
        stars.push(<li className="star" key={i}></li>);
      }
    }
    return <ul className="rating">{stars}</ul>;
  };

  const formatDate = (date) => {
    return `${new Date(date).getDate()}-${new Date(date).getMonth() + 1
      }-${new Date(date).getFullYear()}`;
  };

  const currentUser = isLogin();
  const handleCalendarAuthorization = () => {
    setIsCalendarAuthorized(true);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const nextPage = () => {
    const totalPages = Math.ceil(reviews.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentReviews = reviews.slice(indexOfFirstItem, indexOfLastItem);

  const eventList_column = [
    {
      name: "SERVICE NAME",
      selector: (row, i) => row.service_name,
      sortable: true,
    },
    {
      name: "SERVICE TITLE",
      selector: (row, i) => row.title,
      sortable: true,
    },
    {
      name: "START DATE",
      selector: (row, i) => {
        const date = new Date(row.start);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
      },
      sortable: true,
    },
    {
      name: "",
      selector: (row, i) => {
        const date = new Date();
        const startDate = new Date(row.start);
        const endDate = new Date(row.end);
        const isActive = startDate <= date && endDate >= date;
        return (
          <div>
            <a
              href={isActive ? row.meeting_url : '#'}
              target={isActive ? "_blank" : undefined}
              rel={isActive ? "noopener noreferrer" : undefined}
              style={{ pointerEvents: isActive ? "auto" : "none" }}
            >
              <img
                src={googleMeet}
                alt="Meeting Link"
                style={{
                  width: '30px',
                  height: '30px',
                  opacity: isActive ? 1 : 0.5,
                  cursor: isActive ? "pointer" : "not-allowed"
                }}
              />
            </a>
          </div>
        );
      },
      sortable: true,
    }
  ]

  const eventMeeting = async () => {
    try {
      const response = await axios.get(`/user/get-calendar-event/${authInfo.id}`, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json;charset=UTF-8",
          "Authorization": `Bearer ${authInfo.token}`,
        },
      });
      const formattedEvents = response.data.data.map((event) => ({
        event_id: event.event_id,
        id: event._id,
        user_name: event.user_id.name,
        service_name: event.service_id.name,
        description: event.event_description,
        meeting_url: event.meeting_url,
        meetingTitle: event.event_title,
        start: event.start_datetime,
        end: event.end_datetime,
        title: event.event_title,
        serviceCreator: event.service_id.createdBy.email,
      }));
      const sortedEvents = formattedEvents.sort(
        (a, b) => new Date(a.start) - new Date(b.start)
      );
      setEventList(sortedEvents);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const fetchPastEvents = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const now = new Date();
      const past30Minutes = new Date(now.getTime() - 30 * 60 * 1000).toISOString(); // 30 minutes ago
      const nowISO = now.toISOString();
      const response = await axios.get(
        "https://www.googleapis.com/calendar/v3/calendars/primary/events",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            timeMax: past30Minutes, // @@@@@@ Important line event start time to fetch after 30min , 10min ....
            singleEvents: true,
            orderBy: "startTime",
          },
        }
      );
      const eventsWithMeetLinks = response.data.items.filter(
        (event) =>
          event.conferenceData &&
          event.conferenceData.entryPoints &&
          event.conferenceData.entryPoints.some(
            (entry) => entry.entryPointType === "video"
          )
      );

      const pastEventIDs = eventsWithMeetLinks.map((event) => event.id);

      console.log("pastEvents", pastEventIDs)
      if (pastEventIDs.length > 0) {
        console.log("event not null....", pastEventIDs)
        const url = "/user/updateServiceOrders"
        const eventId = {
          pastEventIDs: pastEventIDs
        }
        axios.put(url, eventId, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': `Bearer ${authInfo.token}`
          }
        }).then((response) => {
          console.log("response", response);
          // closeIframe();
          // toast.success("Advertise Blocked successfully....", { autoClose: 2000 })
          setTimeout(() => {
            // fetchData();
          }, 3000);
        }).catch((error) => {
          console.log("error", error)
        })
      } else {
        console.log("no any event found..")
      }
      return pastEventIDs;
    } catch (error) {
      console.error("Error fetching past events:", error);
      throw error;
    }
  };

  //

  // const block = (advertisementId) => {
  //   const user = isLogin();
  //   if (user === true) {
  //     const url = `https://localhost:7700/user/blockBanner/${advertisementId}`
  //     const blockId = {
  //       blockByUser: authInfo.id
  //     }
  //     axios.put(url, blockId, {
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json;charset=UTF-8',
  //         'Authorization': `Bearer ${authInfo.token}`
  //       }
  //     }).then((response) => {
  //       closeIframe();
  //       toast.success("Advertise Blocked successfully....", { autoClose: 2000 })
  //       setTimeout(() => {
  //         fetchData();
  //       }, 3000);
  //     }).catch((error) => {
  //       console.log("error", error)
  //     })
  //   }
  // }


  // console.log("chargesPayStatus:", chargesPayStatus)
  // const isButtonDisabled = chargesPayStatus.chargePay === null;

  return (
    <React.Fragment>
      <section className="service_details_sec" ref={props.ref}>
        <div className="container">
          <div className="row">
            <div className="com-sm-12" style={{ marginTop: "50px", }}>
              <div className="detail_tab">
                <ul className="nav nav-tabs border-0" id="myTab" role="tablist">
                  {!currentUser ? (
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === "description" ? "active" : ""}`}
                        id="description-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#description"
                        type="button"
                        role="tab"
                        aria-controls="description"
                        aria-selected={activeTab === "description"}
                        onClick={() => setActiveTab("description")}
                      >
                        Description
                      </button>
                    </li>
                  ) : (
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === "description" ? "active" : ""}`}
                        id="description-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#description"
                        type="button"
                        role="tab"
                        aria-controls="description"
                        aria-selected={activeTab === "description"}
                        onClick={() => setActiveTab("description")}
                      >
                        Description
                      </button>
                    </li>
                  )}

                  {/* Reviews Tab */}
                  <li className="nav-item" role="presentation">
                    <button className={`nav-link ${activeTab === "reviews" ? "active" : ""}`}
                      id="reviews-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#reviews"
                      type="button"
                      role="tab"
                      aria-controls="reviews"
                      aria-selected={activeTab === "reviews"}
                      onClick={() => setActiveTab("reviews")}
                    >
                      Reviews
                    </button>
                  </li>

                  {/* Appointment Tab */}
                  {!currentUser ? (
                    ""
                  ) : (
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === "appointment" ? "active" : ""}`}
                        id="appointment-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#appointment"
                        type="button"
                        role="tab"
                        aria-controls="appointment"
                        aria-selected={activeTab === "appointment"}
                        onClick={() => setActiveTab("appointment")}
                      // disabled={chargesPayStatus === null ? true : false}

                      >
                        Appointment
                      </button>
                    </li>
                  )}

                  {/* Seller Location Tab - Replace Meeting Tab */}
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "seller-location" ? "active" : ""}`}
                      id="seller-location-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#seller-location"
                      type="button"
                      role="tab"
                      aria-controls="seller-location"
                      aria-selected={activeTab === "seller-location"}
                      onClick={() => setActiveTab("seller-location")}
                    >
                      Location
                    </button>
                  </li>

                  {/* Commented out Meeting Tab - keeping it for future reference */}
                  {/* {!currentUser ? (
                    ""
                  ) : (
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === "meeting" ? "active" : ""}`}
                        id="meeting-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#meeting"
                        type="button"
                        role="tab"
                        aria-controls="meeting"
                        aria-selected={activeTab === "meeting"}
                        onClick={() => setActiveTab("meeting")}
                      >
                        Meeting
                      </button>
                    </li>
                  )} */}

                </ul>
                <div className="tab-content" id="myTabContent">
                  {!currentUser ? (
                    ""
                  ) : !isCalendarAuthorized ? (
                    <div className={`text-center tab-pane fade ${activeTab === "appointment" ? "show active" : ""}`}
                      id="appointment"
                      role="tabpanel"
                      aria-labelledby="appointment-tab"
                    >
                      <ServiceCalendarAuth
                        onAuthSuccess={() => {
                          handleCalendarAuthorization();
                        }}
                        userId={authInfo.id}
                        authToken={authInfo.token}
                        serviceCreator={serviceCreator}
                        serviceName={serviceName}
                        sellerId={sellerId}
                      />
                    </div>
                  ) : (
                    <div className={`tab-pane fade ${activeTab === "appointment" ? "show active" : ""}`}
                      id="appointment"
                      role="tabpanel"
                      aria-labelledby="appointment-tab"
                    >
                      <p className="mb-0">
                        <ServiceCalendar authToken={authInfo.token} serviceCreator={serviceCreator} chargesPayStatus={chargesPayStatus} serviceName={serviceName} sellerId={sellerId} />
                      </p>
                    </div>
                  )}

                  {/* Seller Location Tab Content */}
                  <div className={`tab-pane fade ${activeTab === "seller-location" ? "show active" : ""}`} 
                       id="seller-location" 
                       role="tabpanel" 
                       aria-labelledby="seller-location-tab">
                    <div className="seller-location-container">
                      <div className="row">
                        <div className="col-12">
                          <div className="card">
                            <div className="card-header">
                              <h5 className="mb-0">
                                <i className="bi bi-geo-alt-fill me-2"></i>
                                Service Provider Location
                              </h5>
                              {props.sellerData?.name && (
                                <p className="text-muted mb-0">
                                  Location of {props.sellerData.name}
                                </p>
                              )}
                            </div>
                            <div className="card-body">
                              {sellerLocationData ? (
                                <SimpleMapDisplay
                                  coordinates={sellerLocationData.coordinates}
                                  address={sellerLocationData.formatted_address}
                                  sellerName={props.sellerData?.name || 'Service Provider'}
                                  height="400px"
                                />
                              ) : (
                                <div className="text-center py-5">
                                  <i className="bi bi-geo-alt text-muted" style={{ fontSize: '3rem' }}></i>
                                  <h5 className="text-muted mt-3">Location Not Available</h5>
                                  <p className="text-muted">
                                    The service provider hasn't shared their location yet.
                                  </p>
                                </div>
                              )}
                              
                              {/* Additional Address Information */}
                              {sellerLocationData && (
                                <div className="mt-4">
                                  <h6>Address Details:</h6>
                                  <div className="row">
                                    {sellerLocationData.street && (
                                      <div className="col-md-6 mb-2">
                                        <strong>Street:</strong> {sellerLocationData.street}
                                      </div>
                                    )}
                                    {sellerLocationData.city && (
                                      <div className="col-md-6 mb-2">
                                        <strong>City:</strong> {sellerLocationData.city}
                                      </div>
                                    )}
                                    {sellerLocationData.state && (
                                      <div className="col-md-6 mb-2">
                                        <strong>State:</strong> {sellerLocationData.state}
                                      </div>
                                    )}
                                    {sellerLocationData.country && (
                                      <div className="col-md-6 mb-2">
                                        <strong>Country:</strong> {sellerLocationData.country}
                                      </div>
                                    )}
                                    {sellerLocationData.zip && (
                                      <div className="col-md-6 mb-2">
                                        <strong>Zip Code:</strong> {sellerLocationData.zip}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Commented out Meeting Tab Content - keeping it for future reference */}
                  {/* {!currentUser ? (
                    ""
                  ) : (
                    <div className={`tab-pane fade ${activeTab === "meeting" ? "show active" : ""}`} id="meeting" role="tabpanel" aria-labelledby="meeting-tab">
                      <DataTableExtensions
                        columns={eventList_column}
                        data={eventList}
                      >
                        <DataTable
                          pagination
                          highlightOnHover
                          noHeader
                          defaultSortField="id"
                          defaultSortAsc={false}
                        />
                      </DataTableExtensions>
                    </div>
                  )} */}

                  {!currentUser ? (
                    props.description ? (
                      <div className={`tab-pane fade ${activeTab === "description" ? "show active" : ""}`}
                        id="description"
                        role="tabpanel"
                        aria-labelledby="description-tab"
                      >
                        <p className="ql-editor ql-discription mb-0">
                          {parse(props.description)}
                        </p>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    <div className={`tab-pane fade ${activeTab === "description" ? "show active" : ""}`}
                      id="description"
                      role="tabpanel"
                      aria-labelledby="description-tab"
                    >
                      <p className="ql-editor ql-discription mb-0">
                        {parse(props.description)}
                      </p>
                    </div>
                  )}

                  {currentUser &&
                    <div className={`tab-pane fade ${activeTab === "order" ? "show active" : ""}`}
                      id="description"
                      role="tabpanel"
                      aria-labelledby="description-tab"
                    >
                      {/* <div className="row">
                        <div className="col-md-8">
                          <div className="card mb-4">
                            <div className="card-header">
                              <h3 className="card-title h5">Milestone-Based Delivery</h3>
                              <p className="card-subtitle text-muted small">How our milestone system works</p>
                            </div>
                            <div className="card-body">
                              <div className="mb-3">
                                {[{
                                  step: 1,
                                  title: "Project Setup",
                                  desc: "After ordering, milestones will be created in your customer portal"
                                }, {
                                  step: 2,
                                  title: "Milestone Tracking",
                                  desc: "Track progress through each phase of your project"
                                }, {
                                  step: 3,
                                  title: "Secure Payments",
                                  desc: "Payments are only released when you approve completed work"
                                }, {
                                  step: 4,
                                  title: "Quality Assurance",
                                  desc: "Request revisions before approving each milestone"
                                }].map(({ step, title, desc }) => (
                                  <div key={step} className="d-flex gap-2 mb-3">
                                    <div
                                      className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center"
                                      style={{ width: "24px", height: "24px", flexShrink: 0 }}
                                    >
                                      <span className="small fw-bold">{step}</span>
                                    </div>
                                    <div>
                                      <p className="fw-medium mb-1">{title}</p>
                                      <p className="text-muted small mb-0">{desc}</p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card mb-4">
                            <div className="card-header">
                              <h3 className="card-title h5">Order Summary</h3>
                            </div>
                            <div className="card-body">
                              <div className="mb-3">
                                <div className="d-flex justify-content-between mb-2">
                                  <span>Service Price</span>
                                  <span>${432}</span>
                                </div>
                                <div className="d-flex justify-content-between text-muted">
                                  <span>Platform Fee (5%)</span>
                                  <span>${Math.round(432 * 0.05)}</span>
                                </div>
                                <hr />
                                <div className="d-flex justify-content-between fw-bold">
                                  <span>Total</span>
                                  <span>${432 + Math.round(432 * 0.05)}</span>
                                </div>
                              </div>

                              <Link href="/customer/checkout">
                                <button className="btn btn-primary w-100 mb-2">Place Order</button>
                              </Link>
                              <button className="btn btn-outline-secondary w-100">Contact Provider</button>
                            </div>
                          </div>

                          <div className="card">
                            <div className="card-header">
                              <h3 className="card-title h5">Need Help?</h3>
                            </div>
                            <div className="card-body">
                              <p className="small">Have questions about this service?</p>
                              <button className="btn btn-outline-secondary w-100">Contact Support</button>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <PlaceOrderModal
                        show={showOrderPopup}
                        onHide={props.onHide}
                        serviceId={props.serviceId}
                        serviceName={props.serviceName}
                        description={props.description}
                        serviceCreator={props.serviceCreator}
                        sellerId={props.sellerId}
                        chargesPayStatus={props.chargesPayStatus}
                        charges={props?.charges}
                      />
                    </div>
                  }


                  {/* Reviews Content */}
                  <div className={`tab-pane fade ${activeTab === "reviews" ? "show active" : ""}`}
                    id="reviews"
                    role="tabpanel"
                    aria-labelledby="reviews-tab"
                  >
                    <div className="row">
                      <div className="r_col col-sm-12 col-md-3">
                        <div className="box_wrapper">
                          <div className="reviews_box">
                            <p className="review_count">
                              Average Rating: {averageRating.toFixed(1)}
                            </p>
                            <p className="rating_point d-inline-flex align-items-center">
                              {renderStarRating(averageRating)}
                            </p>
                            <button
                              className={`btn custom_btn btn_yellow_bordered w-auto d-inline-block ${!authInfo || authInfo.id === undefined ? "disabled" : ""}`}
                              onClick={() => authInfo && authInfo.id !== undefined && openModal()}
                            >
                              Write a review
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-9">
                        <div className="reviews_comments_box overflow-auto" style={{ maxHeight: "350px" }} >
                          {currentReviews.length > 0
                            ? currentReviews.map((review, index) => (
                              <div className="user_comment_box" key={index}>
                                <div className="d-flex align-items-center">
                                  <p className="title mr-auto">
                                    {review.review.title}
                                  </p>
                                  {currentUser &&
                                    review.userId._id === authInfo.id && (
                                      <button
                                        style={{ marginTop: "-14px", float: "right", }}
                                        className="btn btn-link text-danger"
                                        onClick={() => deleteReview(review._id)} >
                                        <FaTrash />
                                      </button>
                                    )}
                                </div>

                                <p className="feedback">
                                  {review.review.description}
                                </p>
                                <p className="rating">
                                  {renderStarRating(review.rating)}
                                </p>
                                <p className="date mb-0">
                                  {review.userId.name} |{" "}
                                  {formatDate(review.createdAt)}
                                </p>
                              </div>
                            ))
                            : ""}

                          {/* Pagination buttons */}
                          <div className="cart-pagination">
                            {reviews.length > itemsPerPage && (
                              <ul className="pagination-wrapper">
                                <li>
                                  <button onClick={prevPage}>Prev</button>
                                </li>
                                {Array(Math.ceil(reviews.length / itemsPerPage))
                                  .fill()
                                  .map((_, index) => (
                                    <li key={index}>
                                      <button
                                        onClick={() =>
                                          handlePageChange(index + 1)
                                        }
                                        className={
                                          currentPage === index + 1
                                            ? "active"
                                            : ""
                                        }
                                      >
                                        {index + 1}
                                      </button>
                                    </li>
                                  ))}
                                <li>
                                  <button onClick={nextPage}>Next</button>
                                </li>
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Modal */}
        <ServiceModal
          isOpen={isModalOpen}
          onClose={closeModal}
          serviceId={props.serviceId}
          authInfo={authInfo}
          fetchApi={fetchApi}
        />
        {/* End Modal */}
      </section>
    </React.Fragment>
  );
}

export default ServiceDetailsTabbing;
